export class DomainError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly details?: unknown
  ) {
    super(message);
    this.name = 'DomainError';

    // Ensure proper prototype chain for instanceof checks
    Object.setPrototypeOf(this, DomainError.prototype);
  }

  public static is(error: unknown): error is DomainError {
    return error instanceof DomainError;
  }

  public toJSON() {
    return {
      name: this.name,
      code: this.code,
      message: this.message,
      details: this.details,
    };
  }
}

export class ValidationError extends DomainError {
  constructor(message: string, details?: unknown) {
    super('VALIDATION_ERROR', message, details);
    this.name = 'ValidationError';

    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}

export class NotFoundError extends DomainError {
  constructor(entity: string, id: string) {
    super('NOT_FOUND', `${entity} with id ${id} not found`);
    this.name = 'NotFoundError';

    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}

export class AuthorizationError extends DomainError {
  constructor(message: string) {
    super('AUTHORIZATION_ERROR', message);
    this.name = 'AuthorizationError';

    Object.setPrototypeOf(this, AuthorizationError.prototype);
  }
}
